import configManager from "../singleton/ConfigManager.js";
import configManagerEmitter from "../utils/configManagerEmitter.js";

AFRAME.registerComponent("local-menu", {
  schema: {
    template: { type: "string" },
    configPath: { type: "string", default: "" },
    configPathValueRequired: { type: "string", default: "true", oneOf: ["true", "false"] }
  },

  init() {
    this.targetEl = this.el;
    this.menuEl = null;

    if (!this.targetEl.id) {
      const eid = this.targetEl.object3D.eid;
      this.targetEl.id = `el-${eid}`;
      console.warn(`local-menu: Target element did not have an ID. Assigned automatically: ${this.targetEl.id}`);
    }

    this.onConfigUpdated = this.handleConfigUpdate.bind(this);
    configManagerEmitter.on("configUpdated", this.onConfigUpdated);

    if (configManager.synced) {
      this.handleConfigUpdate(configManager.config);
    }
  },
  handleConfigUpdate(config) {
    const shouldAttach = this.checkConditions(config);

    if (shouldAttach && !this.menuEl) {
      this.attachMenu();
    } else if (!shouldAttach && this.menuEl) {
      this.removeMenuInstance();
    }
  },

  checkConditions(config) {
    const isVruiEnabled = config?.VRUI?.enabled;
    if (!isVruiEnabled) {
      return false;
    }

    if (this.data.configPath) {
      const pathSegments = this.data.configPath.split(".");
      let configValue = config;
      for (const segment of pathSegments) {
        if (configValue === null || typeof configValue === "undefined") {
          configValue = undefined;
          break;
        }
        configValue = configValue[segment];
      }

      const requiresTruthy = this.data.configPathValueRequired === "true";

      if (requiresTruthy) {
        if (!configValue) {
          return false;
        }
      } else {
        if (configValue !== false) {
          return false;
        }
      }
    }

    return true;
  },

  attachMenu() {
    const menuContainer = document.querySelector("#interactable-menu");
    if (!menuContainer) {
      console.error(`local-menu (${this.targetEl.id}): Menu container '#interactable-menu' not found.`);
      return;
    }

    const menuTemplate = document.querySelector(this.data.template);
    if (!menuTemplate || menuTemplate.tagName !== "TEMPLATE") {
      console.error(
        `local-menu (${this.targetEl.id}): Template selector '${this.data.template}' did not find a valid <template> element.`
      );
      return;
    }

    try {
      const menuFragment = document.importNode(menuTemplate.content, true);
      const menuElement = menuFragment.firstElementChild;

      if (!menuElement) {
        console.error(
          `local-menu (${this.targetEl.id}): Template '${this.data.template}' does not contain a root element.`
        );
        return;
      }

      menuElement.setAttribute("data-interactable-id", this.targetEl.id);
      menuContainer.appendChild(menuElement);
      this.menuEl = menuElement;
    } catch (error) {
      console.error(
        `local-menu (${this.targetEl.id}): Error attaching menu from template '${this.data.template}'.`,
        error
      );
    }
  },

  removeMenuInstance() {
    if (!this.menuEl) return;

    if (this.menuEl.parentNode) {
      this.menuEl.parentNode.removeChild(this.menuEl);
    }
    this.menuEl = null;
  },

  remove() {
    this.removeMenuInstance();
    configManagerEmitter.off("configUpdated", this.onConfigUpdated);
  }
});
